import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "page-content" };
var _hoisted_2 = { id: "main" };
var _hoisted_3 = { class: "container" };
import baseNav from '@student/components/BaseNav.vue';
import baseFooter from '@common/components/BaseFooter.vue';
import schoolCoursesHeader from '@student/pages/SchoolCatalog/SchoolCourses/components/HeaderPanel.vue';
import BaseMobileMenu from '@student/components/BaseMobileMenu.vue';
import TopNav from '@student/pages/Course/CourseLesson/components/TopNav.vue';
import { useRoute, useRouter } from 'vue-router';
import { useTabs } from '@common/ui/ETabs/useTabs';
import { onMounted, watch } from 'vue';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'SchoolCatalog',
    setup: function (__props) {
        var t = useI18n().t;
        var router = useRouter();
        var route = useRoute();
        var _a = useTabs('schoolCourses', [
            {
                name: t('tabs.courses'),
                value: 'schoolCourses',
            },
            {
                name: t('tabs.webinars'),
                value: 'schoolWebinars',
            },
        ]), activeTab = _a.activeTab, tabs = _a.tabs;
        onMounted(function () {
            activeTab.value = route.name;
        });
        watch(function () { return route.name; }, function (newName) {
            activeTab.value = newName;
        });
        var goRoute = function (routeName) {
            router.push({ name: routeName }).catch(function () { });
        };
        return function (_ctx, _cache) {
            var _component_e_icon = _resolveComponent("e-icon");
            var _component_e_tabs = _resolveComponent("e-tabs");
            var _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(baseNav),
                _createVNode(TopNav, { class: "lg:hidden print:hidden" }),
                _createVNode(BaseMobileMenu),
                _createElementVNode("main", _hoisted_2, [
                    _createVNode(schoolCoursesHeader, { class: "mt-10" }),
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_e_tabs, {
                            modelValue: _unref(activeTab),
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return (_isRef(activeTab) ? (activeTab).value = $event : null); }),
                            adaptive: false,
                            tabs: _unref(tabs),
                            class: "my-7.5 flex justify-center md:block",
                            size: "lg",
                            onChange: goRoute
                        }, {
                            "tab-icon-schoolCourses": _withCtx(function () { return [
                                _createVNode(_component_e_icon, {
                                    class: "h-5 w-5 ml-3",
                                    icon: "layers2"
                                })
                            ]; }),
                            "tab-icon-schoolWebinars": _withCtx(function () { return [
                                _createVNode(_component_e_icon, {
                                    class: "h-4 w-5 ml-3",
                                    icon: "webinar-new"
                                })
                            ]; }),
                            _: 1
                        }, 8, ["modelValue", "tabs"])
                    ]),
                    _createVNode(_component_router_view)
                ]),
                _createVNode(baseFooter)
            ]));
        };
    }
});
